module.exports = __webpack_public_path__ + "img/1.2ddd3bcc.png";